import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import { CMSState, Link } from "../../../../cms/blocks/types.gen";
import React from "react";
import { NavLink } from "react-router-dom";
import { toRelativeUrl } from "../../../../../helpers";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { getRandomArbitrary } from "../../../../../utils";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type ImageTextBlockProps<extra_images> = {
  label: number
  taxonomy: WordPress.TaxonomyResponse
  title: string
  show_primary: boolean
  primary_button: Link
  background_color: string
  images: WordPress.MediaResponse[]
  block_index: number
  isInView: boolean
}

export type ImageTextBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

export function ImageTextBlock<customBlockData, extra_images>(
  props: ImageTextBlockProps<extra_images>,
  options?: { style: ImageTextBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: setState => {

        const setBlockState = <K extends keyof ImageTextBlockProps<extra_images>>(prop: K, newValue: ImageTextBlockProps<extra_images>[K]) => (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>): CMSState<customBlockData, extra_images, PublicSite_CustomPageData> => {
          if (!s.blocks.has(props.block_index)) return s
          let current_block = s.blocks.get(props.block_index) as any //as CustomBlockData
          if (current_block.kind != 'imageTextBlock') return s
          current_block = ({
            ...current_block,
            value: {
              ...current_block.value,
              fst: {
                ...current_block.value.fst,
                [prop]: newValue
              },

            }
          })
          return ({ ...s, blocks: s.blocks.set(props.block_index, current_block) })
        }

        if (!props.primary_button.url.endsWith(`?taxonomy=${props.taxonomy.id}`)) {
          props.primary_button.url += `?taxonomy=${props?.taxonomy?.id}`
        }

        return (
          <section className={`home-theme theme--${props.taxonomy?.slug}`}>
            <div className="home-theme__inner">
              <div className="home-theme__content">
                <div className="home-theme__text grid--gutter">
                  {props.taxonomy && props.taxonomy.name && <p className="home-theme__pretitle typo--3xl">{props.taxonomy.name}</p>}
                  {props.title && <h1 className="home-theme__title typo--3xl">{props.title}</h1>}

                  {props.show_primary &&
                    <NavLink className="blob-button" to={toRelativeUrl(props.primary_button.url)}>
                      <>
                      <span className="blob-button__label typo--2xs">{props.primary_button.title}</span>
                      <div className="blob-button__icon" aria-hidden="true" />

                      <div className="blob-button__waves" aria-hidden="true">
                        <svg className="blob-button__wave top-left" preserveAspectRatio="none" height="10" viewBox="0 0 64 10" width="64" xmlns="http://www.w3.org/2000/svg"><path d="m32 7h41.7234192c13.7447739 0 13.7217712-7 21.309082-7s10.5496828 7 19.6493838 7h73.391267c5.398704 0 10.675361-3.53967285 16.074065-3.53967285 4.843061 0 9.808168 3.53967285 14.65123 3.53967285h28.201553c17.673112 0 32 14.326888 32 32s-14.326888 32-32 32c-28.170888 0-56.341777 0-84.512665 0-15.806824 0-18.96208 10-31.487335 10s-16.233429-10-32.234436-10c-22.255188 0-44.510376 0-66.765564 0-17.673112 0-32-14.326888-32-32s14.326888-32 32-32z" fillRule="evenodd" transform="translate(-99 -71)"/></svg>
                        <svg className="blob-button__wave top-right" preserveAspectRatio="none" height="10" viewBox="0 0 64 10" width="64" xmlns="http://www.w3.org/2000/svg"><path d="m32 7h41.7234192c13.7447739 0 13.7217712-7 21.309082-7s10.5496828 7 19.6493838 7h73.391267c5.398704 0 10.675361-3.53967285 16.074065-3.53967285 4.843061 0 9.808168 3.53967285 14.65123 3.53967285h28.201553c17.673112 0 32 14.326888 32 32s-14.326888 32-32 32c-28.170888 0-56.341777 0-84.512665 0-15.806824 0-18.96208 10-31.487335 10s-16.233429-10-32.234436-10c-22.255188 0-44.510376 0-66.765564 0-17.673112 0-32-14.326888-32-32s14.326888-32 32-32z" fillRule="evenodd" transform="translate(-99 -71)"/></svg>
                        <svg className="blob-button__wave bottom" preserveAspectRatio="none" height="10" viewBox="0 0 64 10" width="64" xmlns="http://www.w3.org/2000/svg"><path d="m32 7h41.7234192c13.7447739 0 13.7217712-7 21.309082-7s10.5496828 7 19.6493838 7h73.391267c5.398704 0 10.675361-3.53967285 16.074065-3.53967285 4.843061 0 9.808168 3.53967285 14.65123 3.53967285h28.201553c17.673112 0 32 14.326888 32 32s-14.326888 32-32 32c-28.170888 0-56.341777 0-84.512665 0-15.806824 0-18.96208 10-31.487335 10s-16.233429-10-32.234436-10c-22.255188 0-44.510376 0-66.765564 0-17.673112 0-32-14.326888-32-32s14.326888-32 32-32z" fillRule="evenodd" transform="translate(-99 -71)"/></svg>
                        <div className="blob-button__bubble bottom-left"/>
                        <div className="blob-button__bubble bottom-right"/>
                        <div className="blob-button__bubble top-left"/>
                        <div className="blob-button__bubble top-right"/>
                      </div>
                    </>
                  </NavLink>
                  }
                </div>
              </div>

              <div className="home-theme__visuals" aria-hidden="true">
                {props.taxonomy && props.taxonomy.slug &&
                  <img className="home-theme__bg lazyload" width="860" height="1140" alt=""
                    src="/frontend/images/empty.png"
                    data-src={`/frontend/images/themes/home--${props.taxonomy.slug}-430w.png`}
                    data-srcset={`/frontend/images/themes/home--${props.taxonomy.slug}-430w.png 430w, /frontend/images/themes/home--${props.taxonomy.slug}-860w.png 860w, /frontend/images/themes/home--${props.taxonomy.slug}-1720w.png 1720w`}
                    data-sizes="(min-width: 1720px) 860px, (min-width: 768px) 50vw, 100vw"
                  />
                }
              </div>

              <div className="portraits portraits--mobile">
                {
                  props.images.map((img, i) => {
                    if (i % 3 == 0) {
                      return <div className="portrait portrait--small portrait--home top" data-parallax={getRandomArbitrary(0, 100)}>
                        <div className="portrait__inner">
                          {img && img?.source_url &&
                            <div className="portrait__visual">
                              <img className="portrait__image lazyload" width="300" height="300" alt=""
                                src="/frontend/images/empty.png"
                                data-src={getImageAttribute(img , 'portrait_s', 'source_url')}
                                data-srcset={`${getImageAttribute(img , 'portrait_s', 'source_url')} 300w, ${getImageAttribute(img , 'portrait_l', 'source_url')} 600w`}
                                data-sizes="auto"
                              />
                            </div>
                          }
                        </div>
                      </div>
                    } else if (i % 3 == 1) {
                      return <div className="portrait portrait--large portrait--home center" data-parallax={getRandomArbitrary(0, 100)}>
                        <div className="portrait__inner">
                          {img && img?.source_url &&
                            <div className="portrait__visual">
                              <img className="portrait__image lazyload" width="400" height="400" alt=""
                                src="/frontend/images/empty.png"
                                data-src={getImageAttribute(img , 'portrait_m', 'source_url')}
                                data-srcset={`${getImageAttribute(img , 'portrait_m', 'source_url')} 400w, ${getImageAttribute(img , 'portrait_xl', 'source_url')} 800w`}
                                data-sizes="auto"
                              />
                            </div>
                          }
                        </div>
                      </div>
                    }
                    return <div className="portrait portrait--small portrait--home bottom" data-parallax={getRandomArbitrary(0, 100)}>
                      <div className="portrait__inner">
                        {img && img?.source_url &&
                          <div className="portrait__visual">
                            <img className="portrait__image lazyload" width="300" height="300" alt=""
                              src="/frontend/images/empty.png"
                              data-src={getImageAttribute(img , 'portrait_s', 'source_url')}
                              data-srcset={`${getImageAttribute(img , 'portrait_s', 'source_url')} 300w, ${getImageAttribute(img , 'portrait_l', 'source_url')} 600w`}
                              data-sizes="auto"
                            />
                          </div>
                        }
                      </div>
                    </div>
                  })
                }
              </div>
            </div>
          </section>
        )
      }
    })
  }
}